
import { defineComponent, ref, Ref } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import profileStore from '@/b2c/profile/profile.store';
import authStore from '@/shared/auth/auth.store';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';

export default defineComponent({
    name: 'ProfileDelete',
    components: { BaseDialog },
    setup() {
        const labels = useBlockLabels();
        const showConfirm: Ref<boolean> = ref(false);
        const showSuccess: Ref<boolean> = ref(false);

        const confirmDelete = async(): Promise<void> => {
            showConfirm.value = false;
            await profileStore.deleteProfile();
            showSuccess.value = true;
            setTimeout(deleteSuccess, 2000);
        };

        const tryDelete = (): void => {
            profileStore.clearEditMode();
            showConfirm.value = true;
        };

        const deleteSuccess = (): void => {
            authStore.userLogout();
        };

        return {
            labels,
            showConfirm,
            showSuccess,
            confirmDelete,
            tryDelete,
        };
    },
});
